import React__default from 'react';
import styled, { keyframes } from 'styled-components';

const Container = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-16x892o-0"
})(["align-items:center;display:flex;gap:0.15em;"]);
const wave = /*#__PURE__*/keyframes(["40%{transform:translateY(0em);}60%{transform:translateY(-0.5em);}65%{transform:translateY(-0.5em);}90%{transform:translateY(0.05em);}100%{transform:translateY(0em);}"]);
const Dot = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-16x892o-1"
})(["border-radius:100%;height:0.4em;width:0.4em;animation-name:", ";animation-duration:2s;animation-iteration-count:infinite;"], wave);
const Dot1 = /*#__PURE__*/styled(Dot).withConfig({
  componentId: "sc-storm-ui-40026394__sc-16x892o-2"
})(["animation-delay:0.3s;background:", ""], ({
  theme
}) => theme.color.lightBlue[500]);
const Dot2 = /*#__PURE__*/styled(Dot).withConfig({
  componentId: "sc-storm-ui-40026394__sc-16x892o-3"
})(["animation-delay:0.45s;background:", ";"], ({
  theme
}) => `linear-gradient(90deg, ${theme.color.lightBlue[500]} 0%, ${theme.color.blue[600]} 100%)`);
const Dot3 = /*#__PURE__*/styled(Dot).withConfig({
  componentId: "sc-storm-ui-40026394__sc-16x892o-4"
})(["animation-delay:0.6s;background:", ""], ({
  theme
}) => theme.color.blue[600]);
const AITypingIcon = () => /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Dot1, null), /*#__PURE__*/React__default.createElement(Dot2, null), /*#__PURE__*/React__default.createElement(Dot3, null));

export { AITypingIcon as A };
//# sourceMappingURL=AITypingIcon-DY1Mqn1P.js.map
